import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import InviteTranslatorList from './InviteTranslatorsTable'
import { fetchTranslationView } from 'slices/inviteTranslatorSlice'

const InviteTranslators = () => {
    const dispatch = useDispatch()
    const { id } = useParams()
    const [item, setItem] = React.useState({});
    useEffect(() => {
        const callBack = (success, message, data) => {
            if (success) {
                setItem(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchTranslationView(id, callBack))
    }, [id])

    return (

        <InviteTranslatorList itemId={id} appointmentData={item}/>
    )
}

export default InviteTranslators